export const removeDoubleSpace = (rawValue: string) =>
  rawValue.replace(/  +/g, ' ');
